import Components from "./components";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.common`;

    return angular.module(moduleName, [Components(moduleName)])
                  .name;
}
